import { Palmtree } from "lucide-react";
import { useLang } from "../i18n";

export const Footer = () => {
  const { t } = useLang();
  const goTo = (hash) => (e) => {
    e.preventDefault();
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer data-testid="footer" className="bg-coal text-sand">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 pb-14 border-b border-sand/10">
          <div className="md:col-span-6">
            <div className="flex items-center gap-2 mb-5">
              <Palmtree className="w-5 h-5 text-ember" strokeWidth={1.5} />
              <span className="font-serif text-2xl tracking-tight">{t("nav.brand")}</span>
            </div>
            <p className="text-sand/55 text-sm leading-relaxed max-w-sm">{t("footer.tagline")}</p>
          </div>
          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-sand/40 mb-5">{t("footer.explore")}</p>
            <div className="flex flex-col gap-3 text-sm">
              <a href="#apartments" data-testid="footer-apartments-link" onClick={goTo("#apartments")} className="text-sand/70 hover:text-ember transition-colors w-fit link-sweep">
                {t("footer.apartments")}
              </a>
              <a href="#gevgelija" data-testid="footer-about-link" onClick={goTo("#gevgelija")} className="text-sand/70 hover:text-ember transition-colors w-fit link-sweep">
                {t("footer.about")}
              </a>
            </div>
          </div>
          <div className="md:col-span-3">
            <p className="text-[11px] uppercase tracking-[0.3em] text-sand/40 mb-5">{t("footer.contact")}</p>
            <div className="flex flex-col gap-3 text-sm text-sand/70">
              <span>rentcentar@gmail.com</span>
              <span>+389 78 321 872</span>
              <span>Gevgelija, North Macedonia</span>
            </div>
          </div>
        </div>
        <div className="pt-8 flex flex-col sm:flex-row justify-between gap-3 text-xs text-sand/40">
          <span>© {new Date().getFullYear()} {t("nav.brand")}. {t("footer.rights")}</span>
          <span className="font-serif italic text-sand/50">Gevgelija · 41.14° N, 22.50° E</span>
        </div>
      </div>
    </footer>
  );
};
